module.exports={
	"Form": "DocumentApprovalStepViewManifest",
	"Scope": "DocumentApprovalStep-View",
	"Descriptors":
	{
		"DocumentApprovalStepDetails.IDDocumentApprovalStep":
		{
			"Name": "ID",
			"Hash": "DocStepView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStepIdentity",
				"Group": "DocStepIdentity"
			}
		},
		"DocumentApprovalStepDetails.GUIDDocumentApprovalStep":
		{
			"Name": "GUID",
			"Hash": "DocStepView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStepIdentity",
				"Group": "DocStepIdentity"
			}
		},
		"DocumentApprovalStepDetails.IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepView-IDState",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "DocStepView-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "DocStepView-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepConfig",
				"Group": "DocStepConfig"
			}
		},
		"DocumentApprovalStepDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocStepView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocStepView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocStepView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		},
		"DocumentApprovalStepDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocStepView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "DocStepAudit",
				"Group": "DocStepAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStepIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStepIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "DocStepConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "DocStepConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocStepAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocStepAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
